var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{staticClass:"text-center",attrs:{"value":_vm.overlayUpdate,"z-index":"999999999","opacity":"0.7"}},[_c('loading-spinner'),_c('div',[_vm._v(_vm._s(_vm.$t('common.download_update')))]),_c('small',[_vm._v(_vm._s(_vm.$t('common.auto_reload')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }